import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { format } from 'date-fns';
import PopUpModal from '../Common/PopUpModal';
import Bets from './Bets';

const style = {
    height: 50,
};

class Betslip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            content: [],
        };
    }

    handleClick = (e) => {
        e.preventDefault();
        let { betslip } = this.props;

        this.setState({
            show: true,
            content: <Bets betslip={betslip} closeModal={this.closeModal} />,
        });
    };

    closeModal = () => {
        this.setState({ show: false });
    };

    render() {
        let { betslip } = this.props;
        let { show, content } = this.state;
        let statusStyle = 'bl-grey';

        if (betslip.settlement === 0) {
            statusStyle = 'bl-gray-6';
        } else if (betslip.settlement === 1) {
            statusStyle = 'bl-red-6';
        } else if (betslip.settlement === 2) {
            statusStyle = 'bl-green-6';
        }

        let drawBets = show ? <PopUpModal show={show} content={content} closeModal={this.closeModal} /> : null;

        return (
            <div style={style}>
                <Row md="auto" className={'mx-auto text-center ' + statusStyle + ' bb-light-1 fs-12 text-gray'} onClick={this.handleClick}>
                    <Col xs="2" className="py-1 px-0">
                        <div>
                            <time>{format(betslip.created_at, 'dd/MM/yy')}</time>
                        </div>
                        <div>
                            <time>{format(betslip.created_at, 'kk:mm')}</time>
                        </div>
                    </Col>
                    <Col xs="3" className="lh-50 p-0">
                        {parseFloat(betslip.stake).toFixed(2)} EUR
                    </Col>
                    <Col xs="3" className="lh-50 p-0">
                        {parseFloat(betslip.possible_win).toFixed(2)} EUR
                    </Col>
                    <Col xs="4" className="lh-50 p-0 text-left">
                        {parseFloat(betslip.win).toFixed(2)} EUR
                    </Col>
                </Row>
                {drawBets}
            </div>
        );
    }
}

export default Betslip;
